
export const navbarData = {
  logo: {
    label: "Diya J Cyriac",
    href: "/#home",
  },

  links: [
    { label: "Experience", href: "/#experience" },
    { label: "Skills", href: "/#skills" },
    { label: "Projects", href: "/#projects" },
    { label: "Resume", href: "https://drive.google.com/file/d/1PDyGGSq-vcG29P2qG64dQC-1JVr8tfri/view?usp=sharing" },
  ],

  cta: {
    label: "Contact Me",
    href: "/#contact",
  },
};
